module.exports = __webpack_public_path__ + "img/slide-18.b9835904.jpeg";